export default class {
  constructor() {
    this.label = "";
    this.percent = 0;
    this.validFrom = "";
    this.validTo = "";
    this.active = false;
  }

  hydrate(data) {
    if (void 0 !== data.id) this.id = data.id;
    if (void 0 !== data.label) this.label = data.label;
    if (void 0 !== data.percent) this.percent = Number(data.percent);
    if (void 0 !== data.validFrom) this.validFrom = data.validFrom;
    if (void 0 !== data.validTo) this.validTo = data.validTo;
    if (void 0 !== data.active) this.active = data.active;
  }
}
